import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IEditThresholdDTO,
	IPresetThresholdUpdateDTO,
	IThresholdDTO,
	IUpdateOranThresholdPresetDTO,
} from '@interfaces/alarms/dto/thresholdDTO';
import { DefaultVendorOptions, IPresetThreshold, IThreshold } from '@interfaces/alarms/threshold';
import { IPresetThresholdDataCreateDTO } from '@interfaces/kpi/dto/kpiPresetsDTO';

import { TTechnologiesValues, TVendorsValues } from '@enums/common';

const {
	thresholdTechnologies,
	thresholdVendors,
	thresholds,
	presetsThreshold,
} = URL;

export const getThresholdTechnologies = (): Promise<TTechnologiesValues[]> => {
	return client.get(thresholdTechnologies);
};

export const getThresholdVendors = (): Promise<DefaultVendorOptions[]> => client.get(thresholdVendors);

export const getThresholds = ({ vendor, technology }: IThresholdDTO): Promise<IThreshold[]> => {
	return client.get(thresholds, {
		params: {
			vendor,
			technology,
		},
	});
};

export const setThresholds = (data: IEditThresholdDTO): Promise<void> => {
	return client.post(thresholds, data);
};

export const savePresetThreshold = (data: IPresetThresholdDataCreateDTO): Promise<void> => {
	return client.post(presetsThreshold, data);
};

export const renamePresetThreshold = ({ name, id, description }: IPresetThresholdUpdateDTO): Promise<void> => {
	return client.put(`${presetsThreshold}/${id}`, { name, description });
};

export const renameOranThresholdPreset = ({ name, id, description }: IPresetThresholdUpdateDTO): Promise<void> => {
	return client.put(`${presetsThreshold}/awtg-ran/${id}/rename`, { name, description });
};

export const updateOranThresholdPreset = ({ id, data }: { id: string; data: IUpdateOranThresholdPresetDTO }) => {
	return client.put(`${presetsThreshold}/awtg-ran/${id}`, data);
};

export const deleteThresholdPresetAPI = ({ id }: { id: string }): Promise<void> => {
	return client.post(`${presetsThreshold}/${id}`, {});
};

export const deleteOranThresholdPresetAPI = ({ id }: { id: string }): Promise<void> => {
	return client.post(`${presetsThreshold}/awtg-ran/${id}`, {});
};

export const getPresetsThreshold = (data: IThresholdDTO): Promise<IPresetThreshold[]> => {
	return client.get(presetsThreshold, {
		params: data,
	});
};

export const runExportThresholds = (data: IThresholdDTO): Promise<void> => {
	return client.post(`${thresholds}/export`, undefined, {
		params: data,
	});
};

export const runExportOranThresholds = (
	{ fileType, vendor }: { fileType: string; vendor: TVendorsValues },
): Promise<void> => {
	return client.post(`${thresholds}/export/ran`, undefined, {
		params: { vendor, fileType },
	});
};
